import { useState, useEffect, useCallback } from "react";
import { useAuth } from "../components/auth/AuthContext";
import { getUpdateStatus } from "../api/updateApi";

/**
 * Fetches the update status on mount and exposes a manual refresh function.
 * Used in the nav badge and the UpdatePage.
 */
export function useUpdateStatus() {
  const { token } = useAuth();
  const [status, setStatus]   = useState(null);   // UpdateStatusInfo
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState(null);

  const fetch = useCallback(async () => {
    if (!token) return;
    setLoading(true);
    setError(null);
    try {
      const data = await getUpdateStatus(token);
      setStatus(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [token]);

  // Fetch once on mount
  useEffect(() => { fetch(); }, [fetch]);

  return { status, loading, error, refresh: fetch };
}
